
import Utils from "sources/ts/Utils";
import AbstractDispatcher from "frontools/abstract/AbstractDispatcher";

/**
    * AbstractPage description
    * (c) lg2fabrique 2017
*/

export default class AbstractPage extends AbstractDispatcher {
    /**
    * constructor
    */
    constructor() {
        super();

        Utils.objectFitPolyfill();
    }
}
